export default emailForm

/** @ngInject */
function emailForm() {
    return ({
        restrict: 'E',
        template: require('./email-form.jade')(),
        scope: {
            buttontext: '@',
            buttonbackgroundcolor: '@',
            buttontextcolor: '@',
            emailplaceholder: '@placeholder',
            right: '@',
            left: '@',
            bottom: '@',
            top: '@',
        },
        link(scope) {
            scope.formStyle = {
                position: 'absolute',
                height: '34px',
                right: scope.right,
                left: scope.left,
                bottom: scope.bottom,
                top: scope.top,
                width: '400px',
                margin: 'auto',
            }
            scope.inputStyle = {
                'background-color': '#fff',
                'border': '1px solid #ccc',
                'border-radius': '4px',
                'color': '#555555',
                'font-size': '14px',
                'height': '34px',
                'padding': '6px 12px',
                'width': '250px',
            }
            scope.buttonStyle = {
                'display': 'inline-block',
                'color': scope.buttontextcolor,
                'background-color': scope.buttonbackgroundcolor,
            }
        },
    })
}



// WEBPACK FOOTER //
// ./src/directives/email-form/email-form.js